<div class="core-header-div">
  <core-header-bar class="core-header"></core-header-bar>
</div>

<div class="pending-div">
        <div class="mat-headline-5">Welcome to myvirena.com</div>
        <div class="mat-subtitle-1">
                Unable to login. Please ensure that your browser is not blocking 3rd party cookies and reload the site.
        </div>
</div>
